import {useIntl} from 'react-intl';
import {formatTime} from '../../../../utilis/timeUtilis';
import {insightsMessages as m} from '../insightsMessages';
import {laneClass, type SpeakerCast} from '../transcript/speakers';
import type {TalkStats as TalkStatsResult} from './talkStats';

interface TalkStatsProps {
    stats: TalkStatsResult;
    cast: SpeakerCast;
}

export const TalkStatsBar = ({stats, cast}: TalkStatsProps) => {
    const intl = useIntl();
    const {ratio, longestMonologue, pauses} = stats;
    const onlySpeaker = stats.talkSeconds.client > 0 && stats.talkSeconds.agent === 0
        ? cast.client
        : stats.talkSeconds.agent > 0 && stats.talkSeconds.client === 0 ? cast.agent : null;

    return (
        <div data-testid="insights-talk-stats" className="flex flex-col gap-1.5">
            {ratio && !onlySpeaker && (
                <div className="flex items-center gap-2">
                    <span className="shrink-0 text-footnote text-ink-muted">{intl.formatMessage(m.talkRatio)}</span>
                    <div
                        role="img"
                        aria-label={`${intl.formatMessage(m.talkRatio)}: ${intl.formatMessage(m.talkRatioValue, {speaker: cast.client.name, percent: ratio.client})}, ${intl.formatMessage(m.talkRatioValue, {speaker: cast.agent.name, percent: ratio.agent})}`}
                        className="flex h-1.5 min-w-[64px] flex-1 overflow-hidden rounded-full bg-surface-muted"
                    >
                        <span className={laneClass[cast.client.palette]} style={{width: `${ratio.client}%`}}/>
                        <span className={laneClass[cast.agent.palette]} style={{width: `${ratio.agent}%`}}/>
                    </div>
                </div>
            )}
            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-footnote tabular-nums text-ink-muted">
                {ratio && !onlySpeaker && (
                    <>
                        <span className="inline-flex items-center gap-1.5">
                            <span aria-hidden="true" className={`size-2 rounded-full ${laneClass[cast.client.palette]}`}/>
                            {intl.formatMessage(m.talkRatioValue, {speaker: cast.client.name, percent: ratio.client})}
                        </span>
                        <span className="inline-flex items-center gap-1.5">
                            <span aria-hidden="true" className={`size-2 rounded-full ${laneClass[cast.agent.palette]}`}/>
                            {intl.formatMessage(m.talkRatioValue, {speaker: cast.agent.name, percent: ratio.agent})}
                        </span>
                    </>
                )}
                {onlySpeaker && (
                    <span className="inline-flex items-center gap-1.5">
                        <span aria-hidden="true" className={`size-2 rounded-full ${laneClass[onlySpeaker.palette]}`}/>
                        {intl.formatMessage(m.singleSpeaker, {speaker: onlySpeaker.name})}
                    </span>
                )}
                {longestMonologue && !onlySpeaker && (
                    <span>{intl.formatMessage(m.longestMonologue, {duration: formatTime(longestMonologue.seconds), speaker: cast[longestMonologue.side].name})}</span>
                )}
                <span>{intl.formatMessage(m.pauses, {count: pauses.count})}</span>
            </div>
        </div>
    );
};
